<template>
  <div :class="ui.bkgdColor">
    <v-layout class="text-xs-right mt-2 mr-2">
      <v-spacer/>
      <v-btn :color="ui.textSubheading"
      :disabled="!this.enableDocumentItemAdd()"
      v-if="this.getRolesList.length < 30"
      flat icon @click="openDialog()">
        <v-icon :color="ui.btnColor"> add </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title class="title wplblue0--text">
            New Role
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-model="localForm.title"
                  label="role title in this capacity"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 md4>
                  <v-select
                  v-model="localForm.type"
                  :items="roleType"
                  label="type"
                  prepend-icon="person"
                  hint="role type"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                  v-model="localForm.theme"
                  :items="roleTheme"
                  label="theme"
                  prepend-icon="grid_view"
                  hint="attach. type"
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                  v-model="localForm.ref"
                  label="reference"
                  :rules="ruleMustBeNotUndefinedANDLessThan25"
                  prepend-icon="bookmark"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-if="localForm.theme !== 'Comment'"
                  v-model="localForm.obj"
                  label="role objective"
                  :rules="mustBeLessThanLarge"
                  prepend-icon="account_box"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.resp"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="mustBeLessThanLarge"
                  hint="role description, tasks, responsibilities"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat
            :disabled="this.localForm.type === '' && this.limit > this.getRolesList.length "
            >
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import role from "@/data/forms/mixins/role.js";
import roleFunctions from "@/data/functions/mixins/roleFunctions.js";
import roleOptions from "@/data/options/mixins/roleOptions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    roleOptions,
    roleFunctions,
    role,
    rulesTextfield,
    apptheme,
    generateID,
    docRevsModFunctions,
    listFunctions,
    documentFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getRolesList",
      "getRolesListCounter",
      "getCurrentPage",
      "getDetail",
      "getUser"
    ])
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinner: false,
      limit: 19,
      localForm: {
        title: "",
        type: "",
        theme: "",
        obj: "",
        ref: "",
        resp: ""
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      this.$refs.form.reset();
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // NEW ROLE
        var tempForm = this.generateRoleForm();
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("auto");
        tempForm.basic.idi = this.getRolesListCounter + 1;
        tempForm.basic.title = this.localForm.title;
        tempForm.char.obj = this.localForm.obj;
        tempForm.char.ref = this.localForm.ref;
        tempForm.char.resp = this.localForm.resp;
        tempForm.char.type = this.localForm.type;
        tempForm.char.theme = this.localForm.theme;
        tempForm.char.icon = this.selectIconFromRole(tempForm.char.type);
        tempForm.stats.date = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getRolesList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 6);

        // STORE UPDATE
        this.$store.dispatch("changeRolesList", newList);
        this.$store.dispatch("changeRolesListCounter", tempForm.basic.idi);
        this.saveDocumentRevMod(5.11, 1); // attachment added.
        this.$store.dispatch("changeDataSavePendingIndication", true);

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
